/**
 * SavePhotoContext — the in-flight photo thumbnails (#39-save) and,
 * for a photo capture, the two context questions Save requires (T-10).
 */


export interface SavePhotoContextProps {
  photoUrls: string[];
  hasPhotoPart?: boolean;
  contextRoom: string;
  contextIntent: string;
  handleContextRoomInput: (value: string) => void;
  handleContextIntentInput: (value: string) => void;
}

export function SavePhotoContext({
  photoUrls,
  hasPhotoPart,
  contextRoom,
  contextIntent,
  handleContextRoomInput,
  handleContextIntentInput,
}: SavePhotoContextProps) {
  return (
    <>
      {/* #39-save: the in-flight photo, rendered from the in-memory draft blob
          (NOT IndexedDB — the record is pre-commit here, so the IDB-reading
          CaptureThumbs would render blank). Sits directly above the context
          block because those questions are ABOUT this photo, and it answers
          Red's ask: the human can see the photo is being carried into the save.
          Self-gates to null when there is no photo part or no createObjectURL
          (jsdom) — never a broken image. */}
      {photoUrls.length > 0 && (
        <div data-testid="save-screen-thumbs" style="display:flex;gap:8px;flex-wrap:wrap">
          {photoUrls.map((url, i) => (
            <img
              key={url}
              data-testid={`save-screen-thumb-${i}`}
              src={url}
              alt="Captured photo"
              style="width:72px;height:72px;object-fit:cover;border-radius:12px;border:1px solid var(--mark-border-default);flex:none"
            />
          ))}
        </div>
      )}

      {hasPhotoPart && (
        <section data-testid="save-screen-context-block">
          <label>
            What room is this?
            <input
              type="text"
              data-testid="save-screen-context-room"
              value={contextRoom}
              onInput={(e) => handleContextRoomInput((e.target as HTMLInputElement).value)}
            />
          </label>
          <label>
            What do you want done with it?
            <input
              type="text"
              data-testid="save-screen-context-intent"
              value={contextIntent}
              onInput={(e) => handleContextIntentInput((e.target as HTMLInputElement).value)}
            />
          </label>
        </section>
      )}
    </>
  );
}
